import PropTypes from 'prop-types'

const DELIVERY_TYPES = {
    ELECTRONIC_ONLY: 'ELECTRONIC_ONLY',
    PAPER: 'PAPER'
}

/**
 * @typedef {Object} InvoiceNotificationDeliveryType
 * @property {string} [stringCode]  - The string code for the translation of the delivery type
 * @property {string} [value]       - The delivery type itself
 */
export const invoiceNotificationDeliveryTypePropType = PropTypes.shape({
    stringCode: PropTypes.string,
    value: PropTypes.oneOf(Object.values(DELIVERY_TYPES))
})
